import React from "react";
import LearnLanguages from "../../components/home/LearnLanguages";
import ReadyStartLearn from "../../components/home/ReadyStartLearn";
import OurServices from "../../components/services/sections/OurServices";
import Offers from "../../components/home/Offers";
import TrustedBy from "../../components/services/sections/TrustedBy";
import WhyNTK from "../../components/services/sections/WhyNatakallam";
import LearnerStories from "../../components/home/LearnerStories";
import {
  feature,
  trustedBy,
} from "../../components/home/homeTrustedFeature.js";
export default function Home() {
  return (
    <>
      <LearnLanguages />
      <WhyNTK />
      <OurServices />
      <Offers />
      <TrustedBy {...trustedBy} />
      <LearnerStories />
      <TrustedBy {...feature} />
      <ReadyStartLearn
        header={"Ready to start learning?"}
        paragraph={
          "Learn how NaTakallam can create or improve your organisation’s language learning programme or buy it for yourself."
        }
      />
    </>
  );
}
